import {HSL} from "./hsl";

export const COLORS = [
    new HSL(351, 51, 51), //#e51d3a
    new HSL(31, 91, 55), //#f58f23
    new HSL(58, 90, 55), //#f4ec25
    new HSL(111, 41, 48), //#57ad48
    new HSL(212, 71, 40), //#1d60ae
    new HSL(256, 41, 44)  //#5b429d
  ];